import env from './env';

const BASE = env.ADMIN_API_URL;

/** All admin API endpoints. Prefix: /api/v1/superadmin */
const API = {
  // Auth
  LOGIN: `${BASE}/login`,
  LOGOUT: `${BASE}/logout`,
  EMAIL_EXIST: (email: string) => `${BASE}/emailexist/${email}`,

  // Users
  USERS: `${BASE}/users`,
  USER: (id: string) => `${BASE}/user/${id}`,
  ADD_USER: `${BASE}/user`,
  SIGN_UP_INVITE: `${BASE}/sign-up-invite`,

  // Companies
  COMPANIES: `${BASE}/companies`,
  COMPANY_INFO: (id: string) => `${BASE}/company-info/${id}`,
  COMPANY_UPDATE: `${BASE}/company-update-info`,
  DELETE_COMPANY: `${BASE}/deletecompany`,
  DISABLE_COMPANY: `${BASE}/disablecompany`,
  DEMO_COMPANY: `${BASE}/demoCompany`,
  EXTEND_FREE_TRIAL: `${BASE}/extendFreeTrialCompany`,
  RESET_PILOT_DATA: `${BASE}/company-reset-pilot-data`,
  ACCOUNT_REVIEW: `${BASE}/accountReview`,
  COMPANY_USER_INFO: (id: string) => `${BASE}/company-user-info/${id}`,
  DOWNLOAD_DATA: `${BASE}/download-data`,
  MARKETING_CHANNELS: `${BASE}/getDistinctMarketingChannel`,
  EXPORT_CSV: `${BASE}/companies/export-csv`,

  // Subscriptions & Payments
  SUBSCRIPTIONS: `${BASE}/subscriptions`,
  ADD_MANUAL_SUBSCRIPTION: `${BASE}/addmanualsubscription`,
  EDIT_MANUAL_SUBSCRIPTION: `${BASE}/editmanualsubscription`,
  UPDATE_COMPANY_PLAN: `${BASE}/updatecompanyplan`,
  PURCHASE_ADDONS: `${BASE}/purchaseaddons`,
  PAYMENT_LOGS: (id: string) => `${BASE}/payment-logs/${id}`,

  // Filters
  ADD_FILTER: `${BASE}/add/filters`,
  FILTER_LIST: `${BASE}/list/filterlist`,
  DELETE_FILTER: `${BASE}/deletefilter`,

  // Surveys & Templates
  SURVEYS: `${BASE}/surveys`,
  SURVEY: (id: string) => `${BASE}/surveys/${id}`,
  ADD_SURVEY: `${BASE}/survey/add`,
  SURVEY_TEMPLATES: `${BASE}/surveys/templates`,
  ADD_TEMPLATE: `${BASE}/surveytemplate/add`,
  UPDATE_TEMPLATE: `${BASE}/surveytemplate/update`,
  DELETE_TEMPLATE: (id: string) => `${BASE}/surveytemplate/${id}`,
  TEMPLATE_ORDER_LIST: `${BASE}/surveytemplate/order-list`,
  REORDER_TEMPLATES: `${BASE}/surveytemplate/reorder`,
  TEMPLATE_TAGS: `${BASE}/template/tags`,
  ADD_TEMPLATE_TAG: `${BASE}/template/tags/add`,
  EDITION_LIST: `${BASE}/survey-template/edition/list`,
  THUMBNAIL_LIST: `${BASE}/survey-template/thumbnail/list`,
  SURVEY_FIELDS: (id: string) => `${BASE}/surveys/listFields/${id}`,
  QUIZ_INFO: (id: string) => `${BASE}/surveys/quiz/surveyInfo/${id}`,
  QUIZ_WEIGHTS: (id: string) => `${BASE}/surveys/choiceWeights/${id}`,
  SURVEY_LOGIC: (id: string) => `${BASE}/surveys/logic/${id}`,
  SUSPICIOUS_SURVEYS: (id: string) => `${BASE}/suspicious-surveys/${id}`,
  UNBLOCK_SUSPICIOUS_SURVEY: `${BASE}/unblock-suspicious-survey`,

  // AI
  TESTING_PROMPTS: `${BASE}/testing-prompt/prompts`,
  TESTING_PROMPT: (id: string) => `${BASE}/testing-prompt/prompts/${id}`,
  AI_TEMPLATES: `${BASE}/ai-templates`,
  AI_TEMPLATE: (id: string) => `${BASE}/ai-templates/${id}`,

  // Logs & Stats
  API_LOGS: `${BASE}/apilogs`,
  USAGE_STATS: `${BASE}/usage-stats`,
  ACCESS_LOGS: `${BASE}/accesslogs`,
  ACCESS_LOG_DETAILS: `${BASE}/getAccessLogDetails`,

  // Processes
  AI_THEMATIC_JOBS: `${BASE}/aithematicjobs`,
  AI_THEMATIC_JOBS_SEARCH: `${BASE}/aithematicjobs/search`,
  AI_THEMATIC_JOB_STAGE_RERUN: (id: string) => `${BASE}/aithematicjobs/${id}/stage-rerun`,
  AI_THEMATIC_JOB_CLEAR_DATA: (id: string) => `${BASE}/aithematicjobs/${id}/clear-data`,
  AI_IMPORT_JOBS: `${BASE}/ai-datasource-import-jobs`,
  AI_IMPORT_JOBS_SEARCH: `${BASE}/ai-datasource-import-jobs/search`,

  // Misc
  DEVICES: `${BASE}/getDeviceSubscriptioDetails`,
  TEMPLATE_INFO: `${BASE}/getTemplateInfoDetails`,
  UPDATE_GATEWAY: `${BASE}/updateGatewaySetting`,
  BLOCK_IPS: `${BASE}/companies/blockSignupIPs`,
  LIST_BLOCKED_IPS: `${BASE}/companies/listBlockSignupIP`,
  COUNTRY_AUTOSUGGEST: `${BASE}/country/autosuggest`,

  // Distributions (email/SMS)
  DISTRIBUTION: `${BASE}/distribution`,
  SEND_EMAIL: `${BASE}/distribution/sendemail`,
  SEND_SMS: `${BASE}/distribution/sendsms`,
} as const;

export default API;
